import React from "react";
import {renderChatMessageBody} from "./utils";

export default function ChatMessage({tagOwner, message}) {
  return <div className={"row message-row" + (message.tagOwnerId != tagOwner.id ? " other" : "")}>
    <div className="col-12 message-container">
      <div className={"chat-message" + (message.tagOwnerId != tagOwner.id ? " sent-by-others" : "")}>
        {/*<div*/}
        {/*  className={"chat-message-name"}>{message.tagOwner.name + (message.tagOwner.company ? `, ${message.tagOwner.company}` : "")}</div>*/}
        <div className="chat-message-body">{renderChatMessageBody(message.body)}</div>
      </div>
    </div>
  </div>
}
